<template>
  <section class="product-type">
    <header>
      <h2>{{ productCollection.title }}</h2>
      <p/>
      <div v-html="description"/>
      <p/>
    </header>
    <div class="products row">
      <product-block v-for="product in products"
                     :key="product.id"
                     :product="product"
                     @revealProductDetail="onRevealProductDetail"/>
    </div>
  </section>
</template>

<script>

import productBlock from './Product'

export default {
  components: {
    productBlock
  },
  props: {
    productCollection: {
      type: Object,
      default: null
    }
  },
  computed: {
    products: function () {
      return this.$store.getters['selection/productsByCollection'](this.productCollection)
        .slice()
        .sort((a, b) => a.order !== b.order ? a.order - b.order : a.title.localeCompare(b.title))
    },
    description: function () {
      return this.productCollection.intro !== '' ? this.productCollection.intro : this.productCollection.description
    }
  },
  methods: {
    onRevealProductDetail: function (product, customerGroup, term) {
      this.$emit('revealProductDetail', product, customerGroup, term)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product-overview/ProductCollection.vue